module.exports = __webpack_public_path__ + "static/demo-legend-3cacf55595967bdf12cf257b34bc2209.png";